import { Box, Typography } from '@mui/material'

export const Header = () => {
    return (
        <Box sx={{p: 2, pb: 0}}>
            <Typography variant={'h2'}>Firewall migration</Typography>
            <Typography variant={'body2'} sx={{mt: 2, mb: 2}}>Complete the form in order to migrate your landing zone to the Firewall.</Typography>
            <Typography variant={'body3'}>All actions are saved so you can come back later to finish migration.</Typography>
        </Box>
    )
}

export default Header